var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppSparkPage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#370000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.975 20H20.901V20.923H36.975V20Z",
    fill: "#FABFBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8501 22.909H20.8871V23.832H32.8501V22.909Z",
    fill: "#FABFBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8711 25.817H32.8341V26.74H20.8711V25.817Z",
    fill: "#FABFBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8201 28.726H20.8551V29.649H32.8201V28.726Z",
    fill: "#FABFBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31.635H32.804V32.558H17V31.635Z",
    fill: "#FABFBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.679 9L30.44 13.772L33.298 16.636L32.605 17.304L29.29 13.982C28.237 12.924 27.002 12.64 26.113 13.488C25.167 14.395 14.587 24.412 13.613 25.34C12.752 26.162 12.752 27.133 13.952 28.315L17.723 32.096L17.069 33.02L9 24.802L25.679 9ZM28.572 44.015L23.798 39.315L20.907 36.471L21.607 35.792L24.955 39.092C26.012 40.136 27.247 40.401 28.133 39.54C29.08 38.621 39.233 28.64 40.179 27.722C41.013 26.912 41.013 25.954 39.849 24.788C39.141 24.082 36.513 21.383 36.513 21.383L37.044 20.46L44.64 28.246L28.572 44.015Z",
    fill: "#FA0F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppSparkPage);
export default __webpack_public_path__ + "static/media/B_app_SparkPage.1c5600fd878c61ce05226900ca4f9ac9.svg";
export { ForwardRef as ReactComponent };